import {
  Menu,
  MenuItem,
  FormControlLabel,
  Divider,
  Grid2,
  IconButton,
  Tooltip,
  Checkbox,
  Collapse
} from "@mui/material";
import MaterialBox from "../../../../../components/MaterialBox";
import MaterialTypography from "../../../../../components/MaterialTypography";
import { ExpandMore, FilterAltOff } from "@mui/icons-material";
import { useLoading } from "../../../../../components/Loading";
import { useState } from "react";
import { useSnackbar } from "../../../../../context/popup";
import { fetchData } from "../../../../../services";
import DropDownConfig from "../../../../Utils/DropDownConfig";


const VariantFilterDialog = ({ anchorEl, open, onClose, filterData, setFilterData, onApply }) => {

    const {setCircleLoading} = useLoading();
    const {showSnackbar} = useSnackbar();

    //accordian states
    const [openActive, setOpenActive] = useState(false);
    const [openInsurer, setOpenInsurer] = useState(false);
    const [openMotorVariant, setOpenMotorVariant] = useState(false);
    const [openInsurerModel, setOpenInsurerModel] = useState(false);
    const [openInsurerFuelType, setOpenInsurerFuelType] = useState(false);
    const [openInsurerBodyType, setOpenInsurerBodyType] = useState(false);
    const [openInsurerBodyStyle, setOpenInsurerBodyStyle] = useState(false);

    //options states
    const [options, setOptions] = useState([]);
    const [dropdown, setDropdown] = useState({
        variantId: [],
        modelId: [],
        fuelId: [],
        bodyType: [],
        bodyStyle: [],
    });  

    const sectionHeader = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "3px 5px",
        background: "#e9ecf5",
        borderRadius: "6px",
        cursor: "pointer",
        mb: 0.3,
    };

    const menuItemStyle = {
        borderRadius: "6px",
        my: 0.2,
        mx: 0.5,
        py: 0.3,
        "&:hover": { backgroundColor: "#dfe6ff" },
    };

    const labelStyle = {
        m: 0,
        "& .MuiFormControlLabel-label": { fontSize: "0.8rem" },
    };

    const fetchInsurerList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/reference/general/insurer-master?dropdown=true&isActive=true`)
            
            if(response?.success){
                const formattedInsurers = response?.data?.items?.map((item) => ({
                    value: item?.id,
                    label: item?.companyName,
                })) || [];
                setOptions(formattedInsurers)
            }
            else{
                //throw error
                showSnackbar("Error Fetching Country List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Dropdown:', error);
            showSnackbar(error?.response?.data?.message, "error");
        }
        finally{
            setCircleLoading(false);
        }
    };

    const fetchMotorVariantList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/reference/motor/mmv/variants?dropdown=true`);
            if(response?.success){
                setDropdown((prev) => ({
                    ...prev,        
                    variantId: response?.data?.items?.map((item) => ({
                    value: item?.id,
                    label: item?.name,
                    })),
                }));
            }
        } catch (error) {
            console.error("Error Fetching Data:", error);
            showSnackbar(error?.response?.data?.message, "error");
        } finally {
            setCircleLoading(false);
        }
    };

    const fetchInsurerModel = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/reference/insurer/model?dropdown=true`);
            if(response?.success){
                setDropdown((prev) => ({
                    ...prev,
                    modelId: response?.data?.items?.map((item) => ({
                    value: item?.id,
                    label: item?.name,
                    })),
                }));
            }
        } catch (error) {
            console.error("Error Fetching Data:", error);
            showSnackbar(error?.response?.data?.message, "error");
        } finally {
            setCircleLoading(false);
        }
    };

    const fetchInsurerFuel = async () => {
        setCircleLoading(true);
        try {
        const response = await fetchData(
            `/reference/insurer/key_value_store?dropdown=true&code=${DropDownConfig?.insurerFuelType}`
        );

        setDropdown((prev) => ({
            ...prev,
            fuelId: response?.data?.items?.map((item) => ({
            value: item?.id,
            label: item?.keyName,
            })),
        }));
        } catch (error) {
        console.error("Error Fetching Countries:", error);
        } finally {
        setCircleLoading(false);
        }
    };

    const fetchInsurerBodyType = async () => {
        setCircleLoading(true);
        try {
        const response = await fetchData(`/reference/insurer/body-type?dropdown=true`);

        setDropdown((prev) => ({
            ...prev,
            bodyType: response?.data?.items?.map((item) => ({
            value: item?.id,
            label: item?.name,
            })),
        }));
        } catch (error) {
        console.error("Error Fetching Countries:", error);
        } finally {
        setCircleLoading(false);
        }
    };

    const fetchInsurerBodyStyle = async () => {
        setCircleLoading(true);
        try {
        const response = await fetchData(`/reference/insurer/body-style?dropdown=true`);

        setDropdown((prev) => ({
            ...prev,
            bodyStyle: response?.data?.items?.map((item) => ({
            value: item?.id,
            label: item?.name,
            })),
        }));
        } catch (error) {
        console.error("Error Fetching Countries:", error);
        } finally {
        setCircleLoading(false);
        }
    };

    const handleChange = ({ target: { name, value } }) => {
        setFilterData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const onClearFilters = () => {
        setFilterData({
            isActive: "",
            countryId: "",
            stateId: "",
            districtId: "",
        });
    };


  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{backgroundColor: "rgba(0, 0, 0, 0.3)",}}
      PaperProps={{
          elevation: 3,
          sx: {
            width: 250,
            padding: 1.5,
          },
      }}
    >
        <MaterialBox
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",             
        }}
        >
            {/* Title */}
            <MaterialTypography variant="body2" fontWeight="bold">
                Insurer Variant Filter
            </MaterialTypography>

            {/* Clear Button */}
            <Tooltip title="Clear Filter" disableInteractive>
                <IconButton
                    size="small"
                    onClick={onClearFilters}
                    sx={{ color: "#ce0707ff" }}
                >
                    <FilterAltOff />
                </IconButton>
            </Tooltip>
        </MaterialBox>


      {/* Content */}
        <MaterialBox ml={1} mt={1} sx={{
            maxHeight: 300, 
            overflowY: "auto"}}>
            <Grid2 container>
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => setOpenActive(!openActive)}>
                        <MaterialTypography variant="caption" fontWeight="bold">
                            Active Status
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openActive ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openActive}>
                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: true },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === true} />}
                            label="Active"
                            sx={labelStyle}
                            />
                        </MenuItem>

                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: false },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === false} />}
                            label="Inactive"
                            sx={labelStyle}
                            />
                        </MenuItem>
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Insurer*/}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openInsurer;
                            setOpenInsurer(nextState);

                            if (nextState && options.length === 0) {
                                fetchInsurerList();
                            }
                        }}>
                        <MaterialTypography variant="caption" fontWeight="bold">
                            Insurer
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openInsurer ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openInsurer}>
                        {options?.map((item) => (
                            <MenuItem
                            key={item.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "gInsurerId", value: item.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={<Checkbox size="small" checked={filterData.gInsurerId === item.value} />}
                                label={item.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Motor Variant */}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openMotorVariant;
                            setOpenMotorVariant(nextState);

                            if (nextState && dropdown?.variantId.length === 0) {
                                fetchMotorVariantList();
                            }
                        }}>
                        <MaterialTypography variant="caption" fontWeight="bold">
                            Motor Variant
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openMotorVariant ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openMotorVariant}>
                        {dropdown?.variantId?.map((item) => (
                            <MenuItem
                            key={item.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "mVariantId", value: item.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={<Checkbox size="small" checked={filterData.mVariantId === item.value} />}
                                label={item.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Insurer Model */}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openInsurerModel;
                            setOpenInsurerModel(nextState);

                            if (nextState && dropdown?.variantId.length === 0) {
                                fetchInsurerModel();
                            }
                        }}>
                        <MaterialTypography variant="caption" fontWeight="bold">
                            Insurer Model
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openInsurerModel ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openInsurerModel}>
                        {dropdown?.modelId?.map((item) => (
                            <MenuItem
                            key={item.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "iModelId", value: item.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={<Checkbox size="small" checked={filterData.iModelId === item.value} />}
                                label={item.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Insurer Fuel Type */}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openInsurerFuelType;
                            setOpenInsurerFuelType(nextState);

                            if (nextState && dropdown?.fuelId.length === 0) {
                                fetchInsurerFuel();
                            }
                        }}>
                        <MaterialTypography variant="caption" fontWeight="bold">
                            Insurer Fuel Type
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openInsurerFuelType ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openInsurerFuelType}>
                        {dropdown?.fuelId?.map((item) => (
                            <MenuItem
                            key={item.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "iFuelTypeId", value: item.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={<Checkbox size="small" checked={filterData.iFuelTypeId === item.value} />}
                                label={item.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Insurer Body Type */}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openInsurerBodyType;
                            setOpenInsurerBodyType(nextState);

                            if (nextState && dropdown?.bodyType.length === 0) {
                                fetchInsurerBodyType();
                            }
                        }}>
                        <MaterialTypography variant="caption" fontWeight="bold">
                            Insurer Body Type
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openInsurerBodyType ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openInsurerBodyType}>
                        {dropdown?.bodyType?.map((item) => (
                            <MenuItem
                            key={item.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "iBodyTypeId", value: item.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={<Checkbox size="small" checked={filterData.iBodyTypeId === item.value} />}
                                label={item.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Insurer Body Style */}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openInsurerBodyStyle;
                            setOpenInsurerBodyStyle(nextState);

                            if (nextState && dropdown?.bodyStyle.length === 0) {
                                fetchInsurerBodyStyle();
                            }
                        }}>
                        <MaterialTypography variant="caption" fontWeight="bold">
                            Insurer Body Style
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openInsurerBodyStyle ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openInsurerBodyStyle}>
                        {dropdown?.bodyStyle?.map((item) => (
                            <MenuItem
                            key={item.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "iBodyStyleId", value: item.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={<Checkbox size="small" checked={filterData.iBodyStyleId === item.value} />}
                                label={item.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>

            </Grid2>
        </MaterialBox>

        <Divider />

        {/* Apply button */}
        <MenuItem
        onClick={() => onApply()}
        disableRipple
        sx={{
            padding: "6px 16px", 
            width: "fit-content",
            mx: "auto",  
            borderRadius: "6px",
            backgroundColor: "#93a6e8",
            color: "white",
            display: "flex",
            justifyContent: "center",
            transition: "0.2s ease",

            "&:hover": {
            backgroundColor: "#bcc7e9",
            }
        }}
        >
        <MaterialTypography variant="button" fontWeight="bold">
            APPLY FILTER
        </MaterialTypography>
        </MenuItem>
    </Menu>
  );
};

export default VariantFilterDialog;
